<template>
  <div>
    <strong>Please note:</strong> This action should only be used if arms are assigned through event logic. If participants will be randomized by Way to Health, they will be assigned a cohort at that time (assuming their arm uses cohorts).
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String
    }
  };
</script>




